const { getCardDomains, cardHasType, cardCost } = require('./helpers');
const { validateDeck } = require('./deckValidation');

function count(card) {
  const n = Number(card && card.count);
  return Number.isFinite(n) && n > 0 ? n : 1;
}

function calculateDeckStats(deck) {
  deck = deck || {};
  const mainCards = deck.mainCards || [];
  const runes = deck.runes || [];
  const battlefields = deck.battlefields || [];

  const ccExtra = deck.chosenChampion ? 1 : 0;
  const mainDeckCount = mainCards.reduce((s, c) => s + count(c), 0) + ccExtra;
  const runeCount = runes.reduce((s, c) => s + count(c), 0);

  const byType = (t) => mainCards.filter((c) => cardHasType(c, t)).reduce((s, c) => s + count(c), 0);
  const unitCount = byType('Unit');
  const spellCount = byType('Spell');
  const gearCount = byType('Gear');
  const championCount = mainCards.filter((c) => c.supertype === 'Champion').reduce((s, c) => s + count(c), 0) + ccExtra;

  const costDistribution = {};
  for (const c of mainCards) {
    const cost = cardCost(c);
    costDistribution[cost] = (costDistribution[cost] || 0) + count(c);
  }

  return {
    mainDeckCount,
    runeCount,
    battlefieldCount: battlefields.reduce((s, c) => s + count(c), 0),
    unitCount,
    spellCount,
    gearCount,
    championCount,
    costDistribution,
    legendDomains: deck.legend ? getCardDomains(deck.legend) : [],
    isValid: validateDeck(deck).isValid,
  };
}

module.exports = { calculateDeckStats };
